"use client";

import { useState } from "react";
import axiosInstance from "../../../api/Axiosinstance";
import { ENDPOINTS } from "../../../api/Endpoints";
import { useToast } from "../../../hooks/useToast";
import { getApiErrorMessage } from "../../../utils/apiError";

export const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const toast = useToast();

  const signup = async (formData) => {
    try {
      setLoading(true);
      setError(null);

      const fullName = (formData.fullName || "").trim();
      const rawMobile = (formData.mobile || "").replace(/\s+/g, "");
      const sanitizedMobile = rawMobile.replace(/[^\d+]/g, "");

      // Prepare data for API call (API expects fullName, not first/last)
      const registrationData = {
        fullName,
        email: formData.email.trim().toLowerCase(),
        mobile: sanitizedMobile,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        role: formData.role || "user",
        agreeToTerms: formData.agreeToTerms,
      };

      // Make API call using axios instance
      const response = await axiosInstance.post(
        ENDPOINTS.AUTH.SIGNUP,
        registrationData
      );

      // Return success response with data
      return {
        success: true,
        data: response.data,
      };
    } catch (err) {
      const status = err.response?.status;
      const isOutage = status >= 500 || !err.response;

      if (isOutage) {
        const errorMessage =
          "Service is temporarily unavailable. Please try again shortly.";
        setError(errorMessage);
        toast.error(errorMessage);
        return { success: false, error: errorMessage };
      }

      // A signup rejection often names several fields at once — show them all.
      toast.apiError(err, "Registration failed. Please try again.");
      const errorMessage = getApiErrorMessage(
        err,
        "Registration failed. Please try again."
      );
      setError(errorMessage);
      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    signup,
    loading,
    error,
    clearError,
  };
};
